import {Grid, Typography} from '@mui/material';

interface Props {
  name: string;
  slogan?: string;
  description?: string;
}

export const CompanyDescription = ({name, description, slogan}: Props) => {
  return (
    <Grid item sx={{paddingX: {xs: '16px', sm: '32px'}, paddingBottom: '32px'}}>
      <Typography variant='h2'>{name}</Typography>
      {slogan && <Typography paddingBottom='40px'>{slogan}</Typography>}
      {description && <Typography dangerouslySetInnerHTML={{__html: description}} />}
    </Grid>
  );
};
